<template>
  <div id="app">
    <router-view />
  </div>
</template>

<style lang="scss"></style>

<script>
import Vue from "vue";

import VueFbCustomerChat from "vue-fb-customer-chat";
import VueAnalytics from "vue-analytics";

Vue.use(VueFbCustomerChat, {
  page_id: 110683071093595, //  change 'null' to your Facebook Page ID,
  theme_color: "#333333", // theme color in HEX
  locale: "en_US", // default 'en_US'
});

Vue.use(VueAnalytics, {
  id: "UA-19553488-41",
});

export default {
  data() {
    return {
      isCondensed: false,
    };
  },
};
</script>
<!-- Global site tag (gtag.js) - Google Analytics -->
<script
  async
  src="https://www.googletagmanager.com/gtag/js?id=UA-19553488-41"
></script>
<script>
window.dataLayer = window.dataLayer || [];
function gtag() {
  dataLayer.push(arguments);
}
gtag("js", new Date());

gtag("config", "UA-19553488-41");
</script>
